import { EffectCallback, useRef, useEffect } from "react";

const useConditionalLegacyEffectOnce = (effect: EffectCallback, condition: boolean): void => {
  const hasRunOnce = useRef(false);
  useEffect(() => {
    if (condition && !hasRunOnce.current) {
      effect();
      hasRunOnce.current = true;
    }
  }, [condition]);
};

const useLegacyEffectOnce = (effect: EffectCallback): void => {
  useEffect(() => {
    effect();
  }, []);
};

export { useConditionalLegacyEffectOnce, useLegacyEffectOnce };
